// extracted by mini-css-extract-plugin
module.exports = {"speakers":"speakers-module--speakers--1uJU5","grid":"speakers-module--grid--1n8Jf"};